import React from "react";
import PropTypes from "prop-types";
import Card from "../../components/Card";
import Action from "../../components/Action";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";
import { sanitiseHtml } from "../../utils/sanitiseHtml";

/**
 * Intro screen for anonymous requests.
 * Supports custom intro_screen configuration with title, description and link text.
 */
const AnonymousRequestIntro = ({ title, description, linkText, onContinue }) => {
  const renderDescription = () => {
    if (!description) return null;

    return <div dangerouslySetInnerHTML={{ __html: sanitiseHtml(description) }} />;
  };

  return (
    <>
      <ScrollToTop />
      <Card title={title} removeTopPadding>
        {renderDescription()}
        <Action onClick={onContinue}>{linkText || "Let’s get started"}</Action>
      </Card>
      <Image src={imageOfficeWorking} fullWidth />
    </>
  );
};

AnonymousRequestIntro.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  onContinue: PropTypes.func.isRequired,
};

export default AnonymousRequestIntro;
